export default __webpack_public_path__ + "static/media/kyc-selfie-frame.53540cbf.svg";